"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _ui = require("@probeton/ui");

var _UserOnboarding = _interopRequireDefault(require("./UserOnboarding"));

var _UserBlocking = _interopRequireDefault(require("./UserBlocking"));

var _RepresentativeUnits = _interopRequireDefault(require("./RepresentativeUnits"));

var _RepresentativeAssignUnits = _interopRequireDefault(require("./RepresentativeAssignUnits"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RepresentativeInfo = function RepresentativeInfo(_ref) {
  var person = _ref.person,
      representative = _ref.representative,
      handleUnitClick = _ref.handleUnitClick,
      handlePersonOnboarding = _ref.handlePersonOnboarding,
      handleResendInvitation = _ref.handleResendInvitation,
      handleUserBlock = _ref.handleUserBlock,
      handleUserUnblock = _ref.handleUserUnblock,
      loadingOnboarding = _ref.loadingOnboarding,
      units = _ref.units,
      assignedUnits = _ref.assignedUnits,
      editableUnits = _ref.editableUnits,
      handleUnitChange = _ref.handleUnitChange,
      labels = _ref.labels;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(_ui.ProfileItem, {
    icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
      src: person.avatar && person.avatar.src
    }),
    textLabel: person.email || representative.email,
    text: person.fullName
  }), handleResendInvitation && /*#__PURE__*/_react["default"].createElement(_UserOnboarding["default"], {
    invitedAt: representative && representative.invitedAt && labels.invitedAt({
      date: representative.invitedAt
    }),
    activatedAt: representative && representative.activatedAt && labels.invitedAt({
      date: representative.activatedAt
    }),
    onStartOnboarding: handlePersonOnboarding,
    onResendOnboarding: handleResendInvitation,
    loading: loadingOnboarding,
    activeLabel: labels.status.active,
    notActiveLabel: labels.status.notActive,
    notInvitedLabel: labels.status.notInvited,
    resendOnboardingLabel: labels.actions.resendOnboarding,
    startOnboardingLabel: labels.actions.startOnboarding
  }), handleUserBlock && representative && /*#__PURE__*/_react["default"].createElement(_UserBlocking["default"], {
    blocked: representative.blocked,
    onBlock: handleUserBlock,
    onUnblock: handleUserUnblock,
    blockedLabel: labels.status.blocked,
    blockLabel: labels.actions.block,
    unblockLabel: labels.actions.unblock
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.info.units), assignedUnits ? /*#__PURE__*/_react["default"].createElement(_RepresentativeAssignUnits["default"], {
    units: units,
    assignedUnits: assignedUnits,
    editableUnits: editableUnits,
    handleUnitChange: handleUnitChange,
    handleUnitClick: handleUnitClick
  }) : /*#__PURE__*/_react["default"].createElement(_RepresentativeUnits["default"], {
    units: person.units || [],
    handleUnitClick: handleUnitClick
  }));
};

var _default = RepresentativeInfo;
exports["default"] = _default;